import { Pipe, PipeTransform } from '@angular/core';

/**
 * ä½¿ç¨è¯´æ
 * let message = "ä»å¤©å¤©æ° {0}ï¼å¤å¤å¥½ {1}ã"
 * template:
 * <h1>{{ message| replaceX: 'æ´æ', 'é£å' }}</h1>
 * resule:
 * <h1>ä»å¤©å¤©æ° æ´æï¼å¤å¤å¥½ é£åã</h1>
 */
@Pipe({name: 'replaceX'})
export class FarrisReplaceXPipe implements PipeTransform {
    transform(value: any, ...args: any[]) {
        args.forEach((v, i) => {
            value = value.replace(`{${i}}`, v);
        });

        return value;
    }
}
